import styled from 'styled-components'

const Container = styled.div`
  padding: 2rem;
  
  header {
    margin-bottom: 2rem;
    
    .top--row {
      margin-bottom: 1.5rem;
      
      h2 {
        font-size: 2rem;
        font-weight: 700;
        color: #fff;
        margin: 0 0 0.5rem 0;
      }
      
      .subtitle {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.6);
        margin: 0;
      }
    }
    
    .header--row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;
      
      .search-container {
        position: relative;
        flex: 1;
        max-width: 400px;
        
        .search-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(255, 255, 255, 0.4);
          font-size: 1rem;
        }
        
        .search-input {
          width: 100%;
          padding: 0.875rem 1rem 0.875rem 2.75rem;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          color: #fff;
          font-size: 0.95rem;
          transition: all 0.2s;
          
          &:focus {
            outline: none;
            background: rgba(255, 255, 255, 0.08);
            border-color: ${({ theme }) => theme.primary};
          }
          
          &::placeholder {
            color: rgba(255, 255, 255, 0.4);
          }
        }
      }
      
      .add--btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.875rem 1.5rem;
        background: ${({ theme }) => theme.primary};
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        white-space: nowrap;
        
        &:hover {
          background: ${({ theme }) => theme.primaryHover || theme.primary};
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(79, 70, 229, 0.4);
        }
        
        .icon {
          font-size: 1rem;
        }
      }
    }
  }
  
  .content--container {
    min-height: 400px;
    
    .empty--container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 4rem 2rem;
      background: rgba(255, 255, 255, 0.03);
      border: 2px dashed rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      text-align: center;
      
      h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.8);
        margin: 1rem 0 0.5rem 0;
      }
      
      .instruction {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.5);
        margin: 0 0 2rem 0;
        max-width: 400px;
      }
      
      .add--btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.875rem 1.5rem;
        background: ${({ theme }) => theme.primary};
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        
        &:hover {
          background: ${({ theme }) => theme.primaryHover || theme.primary};
          transform: translateY(-2px);
        }
      }
    }
    
    .merchants--grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 1.5rem;
    }
  }
`

export default Container
